//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OriginalWork from "@/components/post/OriginalWork.vue";
import WorkAudio from "@/components/post/WorkAudio.vue";
import WorkNote from "@/components/post/WorkNote.vue";
import WorkImage from "@/components/post/WorkImage.vue";
import WorkVideo from "@/components/post/WorkVideo.vue";
import { SPECIAL_CHANNEL_ID } from "@/utils/constants";

export default {
  name: "postItem",
  created() {},
  props: ["post", "topic"],
  data() {
    return {
      SPECIAL_CHANNEL_ID: SPECIAL_CHANNEL_ID
    };
  },
  methods: {
    goToPost: function() {
      this.$router.push({ name: "post", params: { id: this.post.objectId } });
    }
  },
  components: {
    OriginalWork,
    WorkAudio,
    WorkNote,
    WorkVideo,
    WorkImage
  }
};



// WEBPACK FOOTER //
// ./src/components/PostItem.vue